import React from "react"
import { graphql } from "gatsby"
import {
  SEO,
  BaseLayout,
  Breadcrumb,
  PageTitle,
  ImageWithLabel,
  ImagePageTitle,
  QrcodeFrame,
  MdxProviderWithConfig,
} from "../components"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { langId } from "../languages"

const LinkTogetherInitiativesTemplate = props => {
  // console.log("LinkTogetherInitiativesTemplate", props)
  const post = props.data.mdx
  const {
    imagePageTitleConfig,
    title,
    description,
    keywords,
    ogImage,
  } = props.data.mdx.frontmatter
  const { baseSlug } = props.data.mdx.fields
  return (
    <BaseLayout
      lang={props.pageContext.langKey}
      baseSlug={props.pageContext.baseSlug}
    >
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        uriPath={props.uri}
        lang={props.pageContext.langKey}
        baseSlug={baseSlug}
        ogImage={ogImage}
      ></SEO>
      <Breadcrumb
        className="linkTogether-initiatives-template__breadcrumb"
        pathArr={[
          { langKey: langId.HOME, baseSlug: "" },
          {
            langKey: langId.LINK_TOGETHER_INITIATIVES,
            baseSlug: post.fields.baseSlug,
          },
        ]}
      ></Breadcrumb>
      <div className="linkTogether-initiatives-template">
        <ImagePageTitle
          type="grey"
          fluidImage={imagePageTitleConfig[0].img.childImageSharp.fluid}
          imgAlt={imagePageTitleConfig[0].imgAlt}
          imgTitle={imagePageTitleConfig[0].imgTitle}
          title={imagePageTitleConfig[0].title}
          category={imagePageTitleConfig[0].category}
        ></ImagePageTitle>
        <div className="linkTogether-initiatives-template__content">
          <div className="linkTogether-initiatives-template__content__paragraph">
            <MdxProviderWithConfig>
              <MDXRenderer>{post.body}</MDXRenderer>
            </MdxProviderWithConfig>
          </div>
        </div>
      </div>
    </BaseLayout>
  )
}

export default LinkTogetherInitiativesTemplate

export const pageQuery = graphql`
  query LinkTogetherInitiativesTemplateQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        ...MdxFrontmatterFragment
        imagePageTitleConfig {
          ...MdxFrontmatterImagePageTitleConfigFragment
          category
        }
      }
      fields {
        baseSlug
        langKey
        slug
        urlSlug
      }
    }
  }
`
